import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Modal, Card, CardContent, CardActions, Typography } from '@mui/material'
import { PageLoader } from 'frame/components'

import { Box, Button } from '@mui/material'
import { DialogClose } from '../components/dialog/dialog-close'

const StyledModal = ({
  className,
  open,
  title,
  titleVariant,
  children,
  onCancel,
  onCancelLabel,
  onConfirm,
  onConfirmLabel,
  options = [],
  animatedIcon,
  flag,
  ...rest
}) => {
  const [lock, setLock] = useState(false) // to lock the modal during api call/loading state

  const noButtons = options.includes('noButtons')
  const noCancelButton = options.includes('noCancelButton')
  const boldHeading = options.includes('boldHeading')

  useEffect(() => {
    if (flag && (flag === 'processed' || flag === 'error')) { // unlock modal/loading state when flag becomes processed or errored
      setLock(false)
      onCancel()
    }
  // eslint-disable-next-line
  }, [flag])

  const onContinue = () => {
    flag && setLock(true)
    onConfirm()
  }

  const onClose = () => lock ? null : onCancel()

  return (
    <Modal open={open ? true : false} onClose={onClose}>
      <Card {...rest}
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          outline: 'none',
          boxShadow: '0px 10px 20px rgba(0, 0, 0, 0.2)',
          width: 500,
          maxHeight: '100%',
          overflowY: 'auto',
          maxWidth: '100%',
          ...className
        }}>
        <div
          style={{
            position: 'absolute',
            top: '10px',
            right: '10px'
          }}>
          <DialogClose onClose={onClose} />
        </div>
        <CardContent>

          {title && (
            <Typography variant={titleVariant ? titleVariant : 'h4'} align="center">
              {boldHeading ? <strong>{title}</strong> : title}
            </Typography>
          )}

          <Typography
            sx={{
              paddingTop: 1,
              marginBottom: -1,
            }}
            variant="body1" align="center">
            {children}
          </Typography>

          {animatedIcon && (
            <Box
              sx={{
                margin: '16px 0px 0px 0px'
              }}>
              {animatedIcon}
            </Box>
          )}

          {lock && (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                position: 'absolute',
                left: 0,
                right: 0,
                bottom: 0,
                width: '100%',
                height: '100%',
                background: 'rgba(244, 246, 248, 0.8)',
                zIndex: 9999,
              }}>
              <PageLoader />
            </Box>
          )}
        </CardContent>

        {!noButtons && (
          <CardActions
            sx={{
              justifyContent: 'center',
            }}>
            <Button fullWidth disabled={lock} data-cy={`delete-btn`} color="primary" variant="contained" onClick={onContinue}>
              {onConfirmLabel ? onConfirmLabel : 'Confirm'}
            </Button>
            {!noCancelButton && (
              <Button fullWidth disabled={lock} data-cy={`cancel-btn`} color='secondary' variant="outlined" onClick={onCancel}>
                {onCancelLabel ? onCancelLabel : 'Cancel'}
              </Button>
            )}
          </CardActions>
        )}
      </Card>
    </Modal>
  )
}

StyledModal.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  open: PropTypes.bool,
  title: PropTypes.string,
  titleVariant: PropTypes.string,
  onCancel: PropTypes.func.isRequired,
  onCancelLabel: PropTypes.string,
  onConfirm: PropTypes.func,
  onConfirmLabel: PropTypes.string,
  options: PropTypes.array,
  flag: PropTypes.string,
}

export default StyledModal
